import React, { useState } from "react";
// import Confetti from "react-confetti";

const levels = [
  {level:1, questions:[
    {content:'Win an iPad! Click to claim!', fake:true, hint:'Too-good-to-be-true offers are usually fake!', img:'https://www.wipersoft.com/wp-content/uploads/2024/03/Chance-To-Win-The-New-iPad-Pro-2.png'},
    {content:'Your friend posted a holiday photo.', fake:false, hint:'Real posts come from known people.', img:'https://c.files.bbci.co.uk/d975/live/bc7f77d0-a292-11ef-b8c0-b996e628df5a.jpg'},
    {content:'Get free coins instantly in the game!', fake:true, hint:'Promises of free coins or money are scams.', img:'https://i.ytimg.com/vi/i8bjKsdrPTg/maxresdefault.jpg'},
    {content:'Breaking News: Zoo announces new panda!', fake:false, hint:'Check sources, real news comes from trustworthy sites.', img:'https://npr.brightspotcdn.com/dims3/default/strip/false/crop/3382x1902+0+176/resize/1400/quality/100/format/jpeg/?url=http%3A%2F%2Fnpr-brightspot.s3.amazonaws.com%2F06%2Feb%2F28290b654389aae73883fe670cf9%2Fap24288714655028.jpg'},
    {content:'Celebrity photo with alien spaceship!', fake:true, hint:'Manipulated images or unbelievable news are fake.', img:'https://lh3.googleusercontent.com/gg-dl/AJfQ9KTs-ZwOhJZIbNKcICQtKTDq9ZE42z8uhhz8j7TQZht268yOgoQt07mBPV8zKdxgKrG54ezi-z6sGJokBzBEgijRcYmyNdbe8-abXn9-Hxz7oqJa476CoDDHD0stH-V3fS1eI9iPfzEcWP7kFlCL9Pu2bSuGdMU4ed9QLjM83y5EVagGLg=s1024'},
    {content:'Local library shares reading tips.', fake:false, hint:'Real posts come from trustworthy sources.', img:'https://d4804za1f1gw.cloudfront.net/wp-content/uploads/sites/50/2020/12/iStock-1133871949-scaled.jpg'}
  ]},
  {level:2, questions:[
    {content:'Win a free iPhone now!', fake:true, hint:'Too-good-to-be-true offers are fake!', img:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSjWBCJyo1JDWd1PykBOgpP6QoRHdCtoDsWyQ&s'},
    {content:'Classmate shares project photo.', fake:false, hint:'Real posts come from friends.', img:'https://sofiapublicschool.edu.in/wp-content/uploads/2024/02/solar-system-project.webp'},
    {content:'Click to get 5000 game coins!', fake:true, hint:'Free coins offers are scams.', img:'https://www.shutterstock.com/image-vector/buy-coins-screen-slot-game-260nw-645179209.jpg'},
    {content:'News: City park opens new playground.', fake:false, hint:'Check sources.', img:'https://www.goparksaisha.hk/wp-content/uploads/2024/10/Football2.jpg'},
    {content:'Amazing! whale seen in pools!', fake:true, hint:'Unbelievable images are usually fake.', img:'https://www.thenationalnews.com/resizer/v2/KOOIUYLRWI26NO5B25ACKKMPSM.jpg?smart=true&auth=aac126c3f0fdf5409afefc7877db9fa4f93a67e61128e5b3382480aea423c5ee&width=800&height=450'},
    {content:'Teacher posts class schedule.', fake:false, hint:'Real posts come from known people.', img:'https://edit.org/img/blog/xny-class-calendar-template-customize-free.jpg'}
  ]},
  {level:3, questions:[
    {content:'Claim free vacation tickets!', fake:true, hint:'Too-good-to-be-true offers are fake!', img:'https://media.assettype.com/gulfnews%2F2024-11-28%2F65m09y34%2FStock___Emirates_scam_18142403525_original_ratio.jpeg'},
    {content:'Friend shares pet photo.', fake:false, hint:'Real posts from friends are genuine.', img:'https://thumbor.forbes.com/thumbor/fit-in/900x510/https://www.forbes.com/advisor/wp-content/uploads/2023/03/happy_dog_being_held_by_woman.jpeg.jpg'},
    {content:'Get free gift cards by clicking here!', fake:true, hint:'Free gift cards offers are scams.', img:'https://play-lh.googleusercontent.com/8UqfvmlkCkcWqtBTknpnmvKy032UUr0VeCSYonve9y5FB0pOLG80Or5508iMdHWMBXez'},
    {content:'News: Museum announces new exhibit.', fake:false, hint:'Real posts are from trustworthy sources.', img:'https://peabody.yale.edu/sites/default/files/styles/cropped_image/public/page-content/2024-12/mind_matter_5K7A2025_AM_web.jpg?itok=bdNWlFfq'},
    {content:'Alien spaceship landed in school yard photo!', fake:true, hint:'Manipulated images are fake.', img:'https://img-v3.deepdreamgenerator.com/1790929/md_movyzr_3266bf3668e730d50b3a388a22d5ebaad8040e88.jpg'},
    {content:'School shares exam schedule.', fake:false, hint:'Posts from known sources are real.', img:'https://srec.ac.in/uploads/resource/src/DaEE9avjcK27032023041502515-5157276exam-schedule-hd-png-download.png'}
  ]}
];

const glowButton = {
  padding: "12px 25px",
  margin: "8px",
  borderRadius: "12px",
  cursor: "pointer",
  fontSize: "16px",
  color: "#fff",
  border: "none",
  transition: "all 0.3s",
  boxShadow: "0 0 10px #fff, 0 0 20px #fff",
};

const FakePostGameModern = () => {
  const [currentLevel, setCurrentLevel] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answered, setAnswered] = useState(false);
  const [hint, setHint] = useState("");
  const [score, setScore] = useState(0);
  const [showConfetti, setShowConfetti] = useState(false);
  const [showBadge, setShowBadge] = useState(false);

  const question = levels[currentLevel].questions[currentQuestion];

  const checkAnswer = (choice) => {
    if (answered) return;
    setAnswered(true);
    if (choice === question.fake) {
      setScore(prev => prev + 1);
      setHint(`✅ Correct! ${question.hint}`);
      setShowConfetti(true);
      setTimeout(() => setShowConfetti(false), 1500);
    } else {
      setHint(`❌ Wrong! ${question.hint}`);
    }

    // Show badge if last level
    if (currentLevel === levels.length - 1 && currentQuestion === levels[currentLevel].questions.length - 1) {
      setShowBadge(true);
      setShowConfetti(true);
      setTimeout(() => setShowConfetti(false), 3000);
    }
  };

  const nextQuestion = () => {
    setAnswered(false);
    setHint("");
    if (currentQuestion < levels[currentLevel].questions.length - 1) {
      setCurrentQuestion(prev => prev + 1);
    } else if (currentLevel < levels.length - 1) {
      setCurrentLevel(prev => prev + 1);
      setCurrentQuestion(0);
    }
  };

  const prevQuestion = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(prev => prev - 1);
      setAnswered(false);
      setHint("");
    }
  };

  const progressPercent = ((currentQuestion + 1) / levels[currentLevel].questions.length) * 100;

  return (
    <div style={{ fontFamily: "'Comic Neue', cursive", display: "flex", flexDirection: "column", alignItems: "center", minHeight: "100vh", background: " #4ca1af", color: "#fff", padding: 20 }}>
      {/* {showConfetti && <Confetti />} */}
      <h2 style={{ textShadow: "2px 2px #000",color:"whitesmoke" }}>🕵️ Spot the Fake Social Post</h2>

      <div style={{ width: "90%", maxWidth: 900, background: "rgba(0,0,0,0.6)", borderRadius: 20, padding: 25, boxShadow: "0 0 30px rgba(0,0,0,0.5)", marginTop: 20 }}>
        {/* Progress */}
        <div style={{ width: "100%", height: 15, background: "#555", borderRadius: 10, marginBottom: 15 }}>
          <div style={{ width: `${progressPercent}%`, height: "100%", background: "linear-gradient(to right, #ffeb3b, #ff5722)", borderRadius: 10, transition: "width 0.5s" }}></div>
        </div>

        {/* Level Info */}
        <div style={{ fontSize: 22, fontWeight: "bold", marginBottom: 15, textAlign: "center" }}>Level {levels[currentLevel].level} | Question {currentQuestion + 1}</div>

        {/* Post Card */}
        <div style={{ background: "rgba(255,255,255,0.1)", borderRadius: 20, padding: 20, boxShadow: "0 0 20px #000", marginBottom: 10, transition: "all 0.3s", cursor: "pointer" }} onClick={() => window.open(question.link, "_blank")}>
          <div style={{ fontSize: 18, fontWeight: "bold", marginBottom: 10,marginTop: 20, display: "flex", justifyContent: "center", gap: "15px" }}>{question.content}</div>
          <img src={question.img} alt="post" style={{ width: "50%", borderRadius: 12, marginBottom: 10, boxShadow: "0 0 15px #fff", transition: "transform 0.3s", display: "flex", justifyContent: "center", gap: "15px",marginLeft:"220px" }} />
        </div>

        {/* Hint */}
        {hint && <div style={{ background: "rgba(255, 235, 59,0.2)", padding: 12, borderRadius: 12, marginTop: 10, color: "#fff", textShadow: "1px 1px #000" }}>{hint}</div>}

        {/* Buttons */}
        <div style={{  marginTop: 20, display: "flex", justifyContent: "center", gap: "15px" }}>
          <button style={{ ...glowButton, background: "#4caf50" }} onClick={() => checkAnswer(false)}>✅ Real</button>
          <button style={{ ...glowButton, background: "#f44336" }} onClick={() => checkAnswer(true)}>❌ Fake</button>
        </div>

        {/* Navigation */}
        <div style={{  marginTop: 20, display: "flex", justifyContent: "center", gap: "15px"}}>
          <button style={{ ...glowButton, background: "#2196f3" }} onClick={prevQuestion}>⬅ Previous</button>
          <button style={{ ...glowButton, background: "#ff9800" }} onClick={nextQuestion}>Next ➡</button>
        </div>
      </div>

      {showBadge && <div style={{ fontSize: 36, color: "#ffeb3b", marginTop: 20, textShadow: "2px 2px #000" }}>🎉 You've earned the Digital Detective Badge! 🕵️‍♀️</div>}
    </div>
  );
};

export default FakePostGameModern;
